module.exports = __webpack_public_path__ + "img/ordHialuronic2.f278dd64.jpg";